export class Poller {
    constructor(callback) {
        this.callback = callback;
        this.pendingTimeoutId = null;
        this.started = false;
    }
    async poll() {
        this.clearPendingTimeout();
        if (this.started) {
            try {
                await this.callback();
            }
            finally {
                this.pendingTimeoutId = setTimeout(() => this.poll(), Poller.POLL_INTERVAL);
            }
        }
    }
    clearPendingTimeout() {
        if (this.pendingTimeoutId !== null) {
            clearTimeout(this.pendingTimeoutId);
        }
    }
    stop() {
        this.started = false;
        this.clearPendingTimeout();
    }
    pollIfStarted() {
        this.poll();
    }
    start() {
        this.started = true;
        this.poll();
    }
}
Poller.POLL_INTERVAL = 5000;
